import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Assignments Config"})
export default class AssignmentsConfig {

	@Input({type: InputType.CHECKBOX, title: "Enable Refine"})
	public enableRefine?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Enable Load More"})
	public enableLoadMore?: boolean;

	@Input({type: InputType.NUMBER, title: "Page Size"})
	public pageSize?: number;

	@Input({type: InputType.CHECKBOX, title: "Expand for description"})
	public enableExpand?: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/assignments/AssignmentsConfig.ts